export function identity<T>(t: T): T {
    return t;
}
